export const processMessage = (message: string) => {
  if (!message) return null;
  const parts = message.split(/(<b>.*?<\/b>)/g);

  return parts.map((part, index) => {
    if (part.startsWith('<b>') && part.endsWith('</b>')) {
      const content = part.replace(/<\/?b>/g, '');
      return <b key={index}>{content}</b>;
    }
    return part;
  });
};
